module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "fm2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#fm2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Types of Markets in Provence")])])]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("TRADITIONAL PROVENÇAL MARKETS")]), _c('br'), _c('strong', [_c('em', [_vm._v("(Marchés Provençaux, Marchés Hebdomadaires)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("These are the most common type of market in Provence. They’re held outdoors year-round (though smaller in winter), from about 8:30 a.m. to noon, usually only once a week. Vendors sell fresh ingredients, prepared foods, flowers, and souvenirs. Farmers might bring local produce; however, these are not farmers’ markets in the pure sense (for that, see below). Some ("), _c('em', [_vm._v("grands marchés")]), _vm._v(") are large and diverse. Others are "), _c('em', [_vm._v("très petit")]), _vm._v(" but still cover the basics. Village markets have a markedly different ambience from city markets.")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("FLEA AND ANTIQUES MARKETS")]), _c('br'), _c('strong', [_c('em', [_vm._v("(Marchés des Antiquités, Brocantes, Puces, and Vide Greniers)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Professional dealers sell at "), _c('em', [_vm._v("les marchés des antiquités. Brocantes")]), _vm._v(" are simpler marketplaces of dealers who rove from town to town selling secondhand items. At "), _c('em', [_vm._v("vide greniers")]), _vm._v(" (“attic-emptiers,” akin to yard sales or car-trunk sales), individuals cast off unwanted household items—often junk, but the occasional dusty treasure.")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('strong', [_vm._v("COVERED MARKETS")]), _c('br'), _c('strong', [_c('em', [_vm._v("(Les Halles)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Indoor markets are open most weekdays, both morning and afternoon. The covered structures help maintain a constant temperature. The main covered markets are in Avignon and Nîmes.")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("FARMERS’ MARKETS")]), _c('br'), _c('strong', [_c('em', [_vm._v("(Marchés Paysans, Marchés des Producteurs, Marchés Agricoles)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Farmers bring seasonal produce (and cheese, jams, honey, and wine) to sell directly. These markets are well supported by the locals, who appreciate the direct connection with producers. Certified organic is indicated by “AB” signage ("), _c('em', [_vm._v("Agriculture Biologique")]), _vm._v(").")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("EVENING MARKETS")]), _c('br'), _c('strong', [_c('em', [_vm._v("(Marchés du Soir)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Evening markets usually feature the local farmers and sometimes include an "), _c('em', [_vm._v("animation")]), _vm._v(" such as a cooking demonstration.")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("CRAFT MARKETS")]), _c('br'), _c('strong', [_c('em', [_vm._v("(Marchés des Artisans, Marchés des Créateurs)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Local artisans sell jewelry, accessories, and other crafts. Some towns attempt to maintain a quality standard. Others have looser rules, and the tacky quotient can soar.")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("SPECIALTY MARKETS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Truffle markets, Christmas markets, and "), _c('em', [_vm._v("santon")]), _vm._v(" markets feature seasonal highlights and attract eager shoppers during the winter.")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('strong', [_vm._v("FARM VISIT MARKETS")]), _c('br'), _c('strong', [_c('em', [_vm._v("(Marchés à la Ferme)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Many farmers participate in the "), _c('em', [_vm._v("Bienvenue à la Ferme")]), _vm._v(" program during the growing season, welcoming visitors to their farms.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49e85c05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm2.vue
// module id = 81
// module chunks = 0